import { useEffect, useRef } from 'react';

export const ADMIN_REALTIME_EVENT = 'crm:admin-realtime';

export const ADMIN_REALTIME_TYPES = Object.freeze({
  accountSynced: 'account.synced',
});

export function publishAdminRealtimeEvent(event) {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(new CustomEvent(ADMIN_REALTIME_EVENT, {
    detail: event,
  }));
}

export function isAdminRealtimeEvent(event) {
  const type = String(event?.type || '').trim();
  return Object.values(ADMIN_REALTIME_TYPES).includes(type);
}

export function useAdminRealtimeEvent(types, onEvent) {
  const onEventRef = useRef(onEvent);
  onEventRef.current = onEvent;

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const allowedTypes = new Set(
      (Array.isArray(types) ? types : [types])
        .map((type) => String(type || '').trim())
        .filter(Boolean),
    );

    if (allowedTypes.size === 0) {
      return undefined;
    }

    const listener = (event) => {
      const realtimeEvent = event?.detail || {};
      const type = String(realtimeEvent?.type || '').trim();
      if (!allowedTypes.has(type)) {
        return;
      }

      onEventRef.current(realtimeEvent);
    };

    window.addEventListener(ADMIN_REALTIME_EVENT, listener);

    return () => {
      window.removeEventListener(ADMIN_REALTIME_EVENT, listener);
    };
  }, [types]);
}
